import { WeeeIcon } from '@/components/common/Icon';
import GroupEditNav from '@/components/group-order/components/GroupEditNav';

export default function CancelBtn({
  isHost,
  intervalGroupOrderData
}: {
  isHost?: boolean; //是否团长, 团员  模式展示分2种
  intervalGroupOrderData: any;
}) {
  return (
    <GroupEditNav
      isHost={isHost}
      onlyChildPopup={isHost ? 'cancel' : 'leave'}
      intervalGroupOrderData={intervalGroupOrderData}>
      <div
        data-testid="btn-cancel-group-order"
        className="flex flex-row items-center h-9 w-9 ml-2 justify-center border-solid border border-[#ffffff66] rounded-full flex-shrink-0">
        <WeeeIcon type="icondelete" style={{ fontSize: 18 }} className=" text-reserved-true-white" />
      </div>
    </GroupEditNav>
  );
}
